import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import './i18n';
import { App } from './App.tsx';

let container = document.getElementById('app')!;
let root = createRoot(container);

root.render(
	<App />
);

// root.render(
// 	<StrictMode>
// 		<App />
// 	</StrictMode>
// );
